<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-back-button @click="$utils.goBack($router)"   text="Quay lại" defaultHref="/tabs/main"></ion-back-button>
        </ion-buttons>
        <ion-title>Lịch sử giao dịch</ion-title>
        <ion-label slot="end" style="margin-right: 2vw"></ion-label>
      </ion-toolbar>
    </ion-header>

    <ion-content>
      <ion-refresher slot="fixed" pullMin="80" pullMax="200" @ionRefresh="refreshData($event)">
        <ion-refresher-content>
        </ion-refresher-content>
      </ion-refresher>

      <div class="options ion-padding">
        <div style="flex: 1; padding-right: 1vw">
          <div>
            Loại hình giao dịch
          </div>
          <div>
            <MySelect2 :quick="true" :options="txOptions" :value="typeFilter" iconSize="large" title="Loại giao dịch" @change="changeFilter"></MySelect2>
          </div>
        </div>
        <div style="flex: 1; padding-left: 1vw">
          <div>
            Nhóm theo
          </div>
          <div>
            <MySelect2 :quick="true" :options="groupOptions" :value="groupFilter" iconSize="large" title="Nhóm giao dịch theo" @change="changeGroupFilter"></MySelect2>
          </div>
        </div>
      </div>

      <div class="transactions" v-if="loaded">
        <template v-if="history && Object.entries(history).length > 0">
          <div v-for="(transactions, date) in history" class="group" :key="date">
            <div class="group-title">
              <div style="flex-grow: 1">
                {{ $moment(date, groupInFormat).format(groupOutFormat) }}
              </div>
              <div style="display: flex; flex-direction: column; font-size: 0.8em; font-weight: normal; text-align: right">
                <div v-if="summary[date].credit > 0" style="color: #090">
                  + {{ $utils.numberFormat(summary[date].credit) }}
                </div>
                <div v-if="summary[date].debit > 0" style="color: #222">
                  - {{ $utils.numberFormat(summary[date].debit) }}
                </div>
              </div>
              <div style="margin-left: 2vw">
                <GimoCoinSymbol></GimoCoinSymbol>
              </div>
            </div>
            <div v-for="(transaction,idx) in transactions" :key="idx" class="tx">
              <div style="flex-grow: 1; margin-left: 2vw">
                <div class="game_title">
                  {{ txTypeMap[transaction.tx_type] }}
                  <template v-if="transaction.account == 'bonus' && transaction.tx_type=='deposit'"> khuyến mãi</template>
                  <template v-if="['order', 'win', 'refund'].includes(transaction.tx_type) && transaction.data && transaction.data[0]">
                    <span style="text-transform: capitalize; font-weight: bold" :class="transaction.data[0].game_title">
                      {{ gameTitles[ transaction.data[0].game_title ] }}
                    </span>
                    <template v-if="String(transaction.data[0].stagenum).indexOf(',') > 0">
                      ({{ String(transaction.data[0].stagenum).split(',').length }} kỳ)
                    </template>
                    <template v-else>
                      kỳ {{ transaction.data[0].stagenum }}
                    </template>
                    <template v-if="transaction.order_id">
                      - MĐ:{{ transaction.order_id }}
                    </template>
                  </template>
                </div>
                <div style="color: #999;">
                  <template v-if="groupFilter == 'month'">
                    Ngày {{ $moment(transaction.created).format("D, [lúc] HH:mm:ss") }}
                  </template>
                  <template v-else>
                    Lúc {{ $moment(transaction.created).format("HH:mm:ss") }}
                  </template>
                  - TK: {{ accountNames[transaction.account] }}
                </div>
              </div>
              <div style="display: flex; flex-direction: column; align-items: center; margin-right: 2vw; font-size: 1.2em">
                <div v-if="transaction.credit > 0" style="color: #090">
                  + {{ $utils.numberFormat(transaction.credit) }}
                </div>
                <div v-if="transaction.debit > 0" style="color: #222">
                  - {{ $utils.numberFormat(transaction.debit) }}
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else style="color:#aaa;text-align: center; padding-top: 5vh">Không tìm thấy giao dịch nào</template>
        <ion-infinite-scroll
          @ionInfinite="loadData($event)"
          threshold="100px"
          id="infinite-scroll"
          :disabled="isDisabled">
          <ion-infinite-scroll-content
            loading-spinner="bubbles"
            loading-text="Đang tải dữ liệu...">
          </ion-infinite-scroll-content>
        </ion-infinite-scroll>
      </div>
      <div v-else style="color:#aaa;text-align: center; padding-top: 5vh" >
        Đang tải dữ liệu
      </div>
    </ion-content>
  </ion-page>
</template>

<style lang="css" scoped>

.options {
  display: flex;
  flex-direction: row;
  margin-bottom: 2vh;
  align-items: center;
}

.group-title {
  background: #d7e6ff;
  padding: 2vw;
  color: #222;
  font-size: 1.2em;
  font-weight: bold;
  text-transform: capitalize;
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: 52px;
}
.tx {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 2vw;
  min-height: 52px;
}

.tx:nth-child(even) {background-color: #f2f2f2;}

.game_title .keno {
  color:#deb248;
}

.game_title .max3d {
    color:#c27bc1;
}

.game_title .max4d {
  color:#e22ebf;
}

.game_title .max3dpro {
  color:#e22ebf;
}

.game_title .mega {
  color:#e24c29;
}
.game_title .power {
  color:#e28829;
}
.game_title .xskt {
  color:#4042aa;
}
</style>

<script>
  import GimoCoinSymbol from '@/components/GimoCoinSymbol.vue';
  import MySelect2 from '@/components/MySelect2';
  import { defineComponent } from 'vue';
  import {
    IonPage,
    IonContent,
    IonHeader,
    IonToolbar,
    IonButtons,
    IonBackButton,
    IonTitle,
    IonRefresher,
    IonRefresherContent,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    IonLabel,
  } from '@ionic/vue';

  export default defineComponent({
    name: 'Transactions',
    components: {
      IonPage,
      IonContent,
      IonHeader,
      IonToolbar,
      IonButtons,
      IonBackButton,
      IonTitle,
      GimoCoinSymbol,
      MySelect2,
      IonRefresher,
      IonRefresherContent,
      IonInfiniteScroll,
      IonInfiniteScrollContent,
      IonLabel,
    },
    data() {
      return {
        loaded: false,
        groupInFormat: 'YYYY-MM-DD',
        groupOutFormat: 'dddd, DD MMMM, YYYY',
        isDisabled: false,
        history: {},
        offset: 0,
        limit: 20,
        summary: {},
        typeFilter: 'all',
        groupFilter: 'day',
        groupOptions: {
          'day': 'Ngày',
          'month': 'Tháng',
        },
        txOptions: {
          "all": "Tất cả",
          "deposit": "Nạp tiền",
          "withdraw": "Rút tiền",
          "order": "Đặt vé",
          "bonus": "Khuyến mãi",
          "win": "Trúng thưởng",
          "refund": "Hoàn tiền",
          "cancel_withdraw": "Hủy rút tiền",
        },
        txTypeMap: {
          "deposit": "Nạp tiền",
          "order": "Mua vé",
          "withdraw": "Rút tiền",
          "bonus": "Khuyến mãi",
          "win": "Trúng thưởng",
          "refund": "Hoàn tiền vé",
          "cancel_withdraw": "Hủy rút tiền",
        },
        accountNames: {
          'deposit': 'Chính',
          'win': 'Thưởng',
          'bonus': 'Khuyến mãi',
        },
        gameTitles: {
          keno: 'Keno',
          power: 'Power',
          mega: 'Mega',
          max3d: 'Max3D',
          max3dpro: '3D Pro',
          max4d: 'Max4D',
        },
      }
    },
    methods: {
      changeGroupFilter(val) {
        this.groupFilter = val;
        if (val == 'month') {
          this.groupInFormat = 'YYYY-MM';
          this.groupOutFormat = 'MMMM, YYYY';
        } else {
          this.groupInFormat = 'YYYY-MM-DD';
          this.groupOutFormat = 'dddd, DD MMMM, YYYY';
        }
        this.refreshData(null);
      },
      changeFilter(val) {
        this.typeFilter = val;
        this.refreshData(null);
      },
      loadData(e, more = true) {
        this.$utils.callAPI("GET",
          "/customers/transactions?type="+this.typeFilter
          +"&group="+this.groupFilter
          +"&offset="+this.offset
        ).then((resp) => {
          this.parseResponse(resp, e, more);
        });
        this.offset += this.limit;

      },
      refreshData(e) {
        this.loaded = false;
        this.offset = 0;

        this.loadData(e, false);
      },
      parseResponse(resp, e, more = false) {
        if (!more) {
          this.history = {};
          this.summary = {};
        }

        if (Object.keys(resp.data.transactions).length == 0) {
          this.isDisabled = true;
        }

        Object.keys(resp.data.transactions).sort().reverse().forEach( (inGroup) => {
          resp.data.transactions[inGroup].sort(( a, b ) => {
            if (a.id > b.id) return -1;
            if (a.id < b.id) return 1;
            return 0;
          });
          if (this.history[inGroup]) {
            this.history[inGroup].push(...resp.data.transactions[inGroup]);
          } else {
            this.history[inGroup] = resp.data.transactions[inGroup];
          }
        });

        for (const group in this.history) {
          this.summary[group] = {
            credit: 0, debit: 0
          }
          for (let i = 0; i < this.history[group].length; i++) {
            this.summary[group].credit += this.history[group][i].credit;
            this.summary[group].debit += this.history[group][i].debit;
          }
        }
        this.$nextTick(()=> {
          this.loaded = true;
          if (e && e.target)
            e.target.complete();
        });
      }
    },
    mounted() {
      this.refreshData()
    }
  });
</script>
